<template>
  <ul class="menu-nav">
    <router-link
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item d-flex justify-content-center align-items-center"
        style="margin:0px; width:60px"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <img
            src="/media/imatge-corporativa/logoxupxup.png"
            style=" width:100%; height: 100%"
          />
        </a>
      </li>
    </router-link>

    <router-link
      :disabled="true"
      to="/teams"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/teams'" class="menu-link" @click="navigate">
          <span class="menu-text"> Teams </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/paths"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/paths'" class="menu-link" @click="navigate">
          <span class="menu-text"> Paths </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/projects"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/projects'" class="menu-link" @click="navigate">
          <span class="menu-text"> Projects </span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/ranking"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/ranking'" class="menu-link" @click="navigate">
          <span class="menu-text"> Ranking </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/about"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/about'" class="menu-link" @click="navigate">
          <span class="menu-text"> About </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/forums"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/forums'" class="menu-link" @click="navigate">
          <span class="menu-text"> Forum </span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/videoblog"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active'
        ]"
      >
        <a :href="'#/forums'" class="menu-link" @click="navigate">
          <span class="menu-text"> VideoBlog </span>
        </a>
      </li>
    </router-link>
  </ul>
</template>

<script>
export default {
  name: "KTMenu",
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    }
  }
};
</script>

<style scoped>
.header-menu.header-menu-layout-tab
  .menu-nav
  > .menu-item.menu-item-active
  > .menu-link {
  background-color: transparent !important;
  border-bottom: transparent !important;
}
.header-menu-mobile .menu-nav > .menu-item.menu-item-active > .menu-link {
  display: inline;
}
@media (max-width: 991.98px) {
  .header-menu-mobile .menu-nav > .menu-item.menu-item-active > .menu-link {
    display: none;
  }
}
</style>
